import { render, staticRenderFns } from "./lack_song_set.vue?vue&type=template&id=46946980"
import script from "./lack_song_set.vue?vue&type=script&lang=js"
export * from "./lack_song_set.vue?vue&type=script&lang=js"
import style0 from "./lack_song_set.vue?vue&type=style&index=0&id=46946980&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports